import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { debounceTime, filter } from 'rxjs/operators';
import { BodegaService } from 'src/app/services/bodega.service';
import { FamiliaService } from 'src/app/services/familia.service';
import { FormatoProductosService } from 'src/app/services/formato-productos.service';
import { InventarioFisicoDetalleService } from 'src/app/services/inventario-fisico-detalle.service';
import { InventarioFisicoService } from 'src/app/services/inventario-fisico.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { RubroService } from 'src/app/services/rubro.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FileDownloadService } from 'src/app/shared/services/file-download.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalSeleccionarProductoComponent } from 'src/app/views/shared/modal-seleccionar-producto/modal-seleccionar-producto.component';

interface IDetalleDocumento {
  rut_empresa: number;
  sucursal_codigo: number;
  producto_codigo: number;
  sku: string;
  producto_nombre: string;
  formato_codigo: string;
  formato_nombre: string;
  bodega_codigo: number;
  bodega_nombre: string;
  rubro_codigo: number;
  rubro_nombre: string;
  familia_codigo: number;
  familia_nombre: string;
  seleccion: boolean;
}
@Component({
  selector: 'app-modal-add-edit',
  templateUrl: './modal-add-edit.component.html',
  styleUrls: ['../exist-inventario-fisico.component.scss'],
  providers: [SecurityService],
})
export class ExistInventarioFisicoModalAddEditComponent implements OnInit {
  @Output() onSuccess: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild('tomaInventario', { static: true }) tomaInventarioModal: ModalDirective;
  @ViewChild(ModalSeleccionarProductoComponent, { static: true }) modalSeleccionarProducto: ModalSeleccionarProductoComponent;

  // Data & Tmp
  public rutEmpresa: number;
  public sucursalCodigo: number;
  public rutUsuario: number;

  // Form
  formHeader: FormGroup;
  formHeaderDefaultValues;
  formDetails: FormGroup;
  productoSeleccionado: any = null;
  paginationContext: PaginationContext = new PaginationContext();

  optionsBodega: Array<any> = [];
  optionsRubro: Array<any> = [];
  optionsFamilia: Array<any> = [];
  optionsFormato: Array<any> = [];

  movimiento: any;
  detalleDocumento: IDetalleDocumento[];
  detalleDocumentoAll: IDetalleDocumento[];
  estado_inventario_codigo: number;
  mode: 'ADD' | 'EDIT';
  processing: boolean = false;

  readonly TIPO_MAYOR_A_CERO: Number = 20;
  readonly TIPO_IGUAL_A_CERO: Number = 21;

  // Utils
  private log: any;

  constructor(
    private accesolocalstorage: SecurityService,
    private messageRendererService: MessageRendererService,
    private clog: ConsoleService,
    private toastService: ToastService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private formatoProductoService: FormatoProductosService,
    private bodegaServ: BodegaService,
    private datesService: DatesService,
    private rubroService: RubroService,
    private familiaService: FamiliaService,
    private inventarioFisicoDetalleService: InventarioFisicoDetalleService,
    private inventarioFisicoService: InventarioFisicoService,
    private fileDownloadService: FileDownloadService
  ) {
    this.log = this.clog.log('INVENTARIO/ADD-EDIT');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.rutUsuario = Number(this.accesolocalstorage.getRutUsuario());

    this.paginationContext.RecordsByPage = 10;

    // Bodegas
    this.loadBodegas();

    // Rubros
    this.loadRubros();

    this.createForms();
    this.formChangesSubscriptions();
  }

  loadBodegas() {
    this.bodegaServ.GetBodegas(this.rutEmpresa, this.sucursalCodigo, ({ mensajes, respuesta }) => {
      const { registros } = respuesta;
      this.optionsBodega = registros.map((bodega) => ({ value: bodega.codigo, label: bodega.nombre, sucursal_codigo: bodega.sucursal_codigo, codigo: bodega.codigo }));
    });
  }

  private loadRubros() {
    this.rubroService.obtenerRubros(this.rutEmpresa, ({ respuesta }) => {
      const { registros } = respuesta; //.registros.filter(p => p.estado);
      this.optionsRubro = registros.map((p) => ({ value: p.codigo, label: p.descripcion }));
    });
  }

  onRubroSelect(ev) {
    this.optionsFamilia = [];

    const listaRubros = this.formHeader.get('rubro').value;
    if (!listaRubros) return;

    for (let i = 0; i < listaRubros.length; i++) {
      this.loadFamilias(listaRubros[i]);
    }
  }

  private loadFamilias(codigoRubro: Number) {
    this.familiaService.obtenerFamiliaxRubro(this.rutEmpresa, codigoRubro, ({ respuesta }) => {
      const { registros } = respuesta; //.registros.filter(p => p.estado);
      let options = registros.map((p) => ({ value: p.codigo, label: p.nombre }));
      this.optionsFamilia = this.optionsFamilia.concat(options);
    });
  }

  createForms() {
    this.formHeader = this.fb.group({
      fecha: [null, [Validators.required]],
      bodega: [null, [Validators.required]],
      rubro: [[]],
      familia: [[]],
      filtraSaldo: [false, [Validators.required]],
      mayorCero: [this.TIPO_MAYOR_A_CERO, [Validators.required]],
    });
    this.formDetails = this.fb.group({
      codigo: [null, [Validators.required]],
      formato: [null, [Validators.required]],
    });

    this.formHeaderDefaultValues = {
      fecha: null,
      bodega: null,
      rubro: [],
      familia: [],
      filtraSaldo: false,
      mayorCero: this.TIPO_MAYOR_A_CERO,
    };
    // this.setFormHeaderDefaultValues()
  }

  setFormHeaderDefaultValues() {
    this.formValidatorsService.setDefaultValues(this.formHeader, this.formHeaderDefaultValues);
  }

  formChangesSubscriptions() {
    this.formHeader.get('bodega').valueChanges.subscribe((bodega: string) => {
      if (this.mode === 'EDIT') {
        this.detalleDocumentoAll = null;
        this.detalleDocumento = null;
      }
    });

    this.formHeader.get('rubro').valueChanges.subscribe((rubro: string) => {
      this.onRubroSelect(rubro);
    });

    this.formDetails
      .get('codigo')
      .valueChanges.pipe(filter(Boolean), debounceTime(1000))
      .subscribe((codigo: string) => {
        if (!codigo) return;
        this.modalSeleccionarProducto.searchBySKU(codigo);
        this.modalSeleccionarProducto.clearLast();
      });
  }

  show() {
    this.mode = 'ADD';
    this.cleanup();
    this.setAddDefaultValues();
    this.log(this.formHeader.value);
    this.tomaInventarioModal.show();
  }

  cleanup() {
    this.headerCleanup();
    this.detailsCleanup();
  }

  headerCleanup() {
    this.formValidatorsService.reset(this.formHeader);
    this.setFormHeaderDefaultValues();
  }

  detailsCleanup() {
    this.productInputCleanup();
    this.detalleDocumentoAll = null;
    this.detalleDocumento = null;
  }

  productInputCleanup() {
    this.formValidatorsService.reset(this.formDetails);
    this.productoSeleccionado = null;
    this.optionsFormato = [];
  }

  setAddDefaultValues() {
    const now = this.datesService.CurrentDateToShortTimeString();
    this.formHeader.get('fecha').setValue(now);
  }

  load(mov: any) {
    this.mode = 'EDIT';
    this.movimiento = mov;
    this.cleanup();
    this.loadInventarFisico(mov);
    this.tomaInventarioModal.show();
  }

  loadInventarFisico(mov) {
    const { rut_empresa, sucursal_codigo, codigo } = mov;
    const inputParams = {
      entidad: {
        rut_empresa,
        sucursal_codigo,
        codigo,
      },
    };

    this.log('inputParams', JSON.stringify(inputParams));

    this.inventarioFisicoService.obtenerInventarFisico(inputParams, ({ respuesta, mensajes }) => {
      const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      const { detalleInventarioFisico, totalRegistros, paginaActual, totalPaginas } = respuesta;

      this.paginationContext.RecordsCount = detalleInventarioFisico.length; //totalRegistros
      this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage); //totalPaginas
      this.paginationContext.CurrentPage = 1; // paginaActual

      //  header data
      this.formHeader.get('fecha').setValue(respuesta.fecha_creacion);
      this.formHeader.get('bodega').setValue(respuesta.bodega_codigo);

      // details data
      detalleInventarioFisico.map((detalle, index) => {
        delete detalle.__typename;
        detalle.additionalInfo = {
          checked: false,
          index,
        };
      });

      this.estado_inventario_codigo = respuesta.estado_inventario_codigo;

      this.detalleDocumentoAll = detalleInventarioFisico;
      this.showPage(this.paginationContext.CurrentPage);
    });
  }

  showPage(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber;
    const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage;
    this.detalleDocumento = _.slice(this.detalleDocumentoAll, start, start + this.paginationContext.RecordsByPage);
  }

  abrirModalSeleccionarProducto() {
    this.modalSeleccionarProducto.show();
  }

  onProductoSeleccionado({ data: _productoSeleccionado, origen }) {
    this.productoSeleccionado = _productoSeleccionado;
    this.cleanProductoSeleccionadoRelateds();
    this.formDetails.get('codigo').setValue(_productoSeleccionado.sku);
    this.formatoProductoService.GetFormatosByCodigo(this.rutEmpresa, this.productoSeleccionado.codigo, ({ mensajes, respuesta }) => {
      this.optionsFormato = respuesta.registros.map((formato) => ({ value: formato.formato_codigo, label: formato.formato_nombre, ...formato }));
      this.formValidatorsService.selectDefaultFormatoProducto(this.formDetails.get('formato'), this.optionsFormato);
    });
  }

  cleanProductoSeleccionadoRelateds() {
    this.optionsFormato = [];
    this.formDetails.get('formato').setValue(null);
    this.formDetails.get('formato').markAsPristine();
    this.formDetails.get('formato').markAsUntouched();
  }

  onProductoNoEncontrado() {
    this.productoSeleccionado = null;
    this.optionsFormato = [];
    this.formDetails.get('formato').setValue(null);
  }

  agregarProducto() {
    let valid = this.formValidatorsService.validate(this.formDetails);

    if (!this.formHeader.get('bodega').value) {
      this.toastService.error('Seleccione bodega');
      valid = false;
    }

    if (!valid) return;

    let detalle = this.detalleDocumentoAll ? _.cloneDeep(this.detalleDocumentoAll) : [];
    detalle.map((detalle: any) => {
      // delete detalle.saldo_actual
      delete detalle.additionalInfo;
    });
    const inputParams = {
      entidad: {
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        bodega_codigo: this.formHeader.get('bodega').value,
        producto_codigo: this.productoSeleccionado.codigo,
        formato_codigo: this.formDetails.get('formato').value,
      },
      detalle,
      paginaActual: 1,
      cantidadRegistrosPorPagina: -1,
    };

    this.log('inputParams', JSON.stringify(inputParams));

    this.inventarioFisicoDetalleService.agregarProductoInventarioFisico(inputParams, ({ respuesta, mensajes }) => {
      const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      const { registros, totalRegistros, paginaActual, totalPaginas } = respuesta;
      registros.map((detalle, index) => {
        delete detalle.__typename;
        detalle.additionalInfo = {
          checked: false,
          index,
        };
      });

      this.detalleDocumentoAll = registros;

      // this.paginationContext.RecordsCount = this.detalleDocumentoAll.length //totalRegistros
      // this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage) //totalPaginas
      // this.paginationContext.CurrentPage = this.paginationContext.PagesCount // lastPage // paginaActual
      this.setPagination(this.detalleDocumentoAll);

      this.toastService.success('Producto agregado');
      this.productInputCleanup();
      this.showPage(this.paginationContext.CurrentPage);
    });
  }

  private setPagination(detalleDocumentoAll: any[]) {
    this.paginationContext.RecordsCount = this.detalleDocumentoAll.length; //totalRegistros
    this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage); //totalPaginas
    this.paginationContext.CurrentPage = this.paginationContext.PagesCount; // lastPage // paginaActual
  }

  checkAllChange({ checked }) {
    this.detalleDocumentoAll.forEach((detalle: any) => {
      detalle.seleccion = checked;
      detalle.additionalInfo.checked = checked;
    });
    this.detalleDocumento.forEach((detalle: any) => {
      detalle.seleccion = checked;
      detalle.additionalInfo.checked = checked;
    });
  }

  checkDetalle({ index, checked }) {
    const selectedMain: any = this.detalleDocumentoAll.filter((detalle: any) => detalle.additionalInfo.index === index)[0];
    selectedMain.additionalInfo.checked = !checked;
    selectedMain.seleccion = !checked;

    const selected: any = this.detalleDocumento.filter((detalle: any) => detalle.additionalInfo.index === index)[0];
    selected.additionalInfo.checked = !checked;
    selectedMain.seleccion = !checked;
  }

  eliminarProducto(index: number) {
    this.detalleDocumentoAll = this.detalleDocumentoAll.filter((detalle: any) => detalle.additionalInfo.index !== index);
    this.detalleDocumento = this.detalleDocumento.filter((detalle: any) => detalle.additionalInfo.index !== index);
    this.setPagination(this.detalleDocumentoAll);
  }

  eliminarProductosSeleccionados() {
    this.detalleDocumentoAll = this.detalleDocumentoAll.filter((detalle: any) => !detalle.additionalInfo.checked);
    this.detalleDocumento = this.detalleDocumento.filter((detalle: any) => !detalle.additionalInfo.checked);
    this.setPagination(this.detalleDocumentoAll);
  }

  buscarYAgregar() {
    if (!this.formHeader.get('bodega').value) {
      this.toastService.error('Seleccione bodega');
      return;
    }

    let detalle = this.detalleDocumentoAll ? _.cloneDeep(this.detalleDocumentoAll) : [];
    detalle.map((detalle: any) => {
      // delete detalle.saldo_actual
      delete detalle.additionalInfo;
    });
    const inputParams = {
      entidad: {
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        bodega_codigo: this.formHeader.get('bodega').value,
        listaRubro: this.formHeader.get('rubro').value,
        listaFamilia: this.formHeader.get('familia').value ? _.uniq(this.formHeader.get('familia').value) : [],
        filtraSaldo: this.formHeader.get('filtraSaldo').value,
        mayorCero: this.formHeader.get('mayorCero').value === this.TIPO_MAYOR_A_CERO,
      },
      detalle,
      paginaActual: 1,
      cantidadRegistrosPorPagina: -1,
    };

    this.log('inputParams', JSON.stringify(inputParams));

    this.inventarioFisicoDetalleService.obtenerProductoInventarioFisico(inputParams, ({ respuesta, mensajes }) => {
      const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      const { registros, totalRegistros, paginaActual, totalPaginas } = respuesta;
      registros.map((detalle, index) => {
        delete detalle.__typename;
        detalle.additionalInfo = {
          checked: false,
          index,
        };
      });

      const dataLoaded = this.detalleDocumentoAll !== null && this.detalleDocumentoAll !== undefined && this.detalleDocumentoAll.length !== 0;
      this.log('dataLoaded', dataLoaded, this.detalleDocumentoAll);
      // if (!this.detalleDocumentoAll) this.detalleDocumentoAll = []
      // this.detalleDocumentoAll = this.detalleDocumentoAll.concat(registros)
      this.detalleDocumentoAll = registros;

      this.paginationContext.RecordsCount = this.detalleDocumentoAll.length; //totalRegistros
      this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage); //totalPaginas
      this.paginationContext.CurrentPage = this.paginationContext.PagesCount; // lastPage // paginaActual

      this.toastService.success('Producto(s) agregado(s)');
      this.showPage(dataLoaded ? this.paginationContext.CurrentPage : 1);
    });
  }

  onPageChange(context: PaginationContext) {
    this.showPage(context.RequestedPage);
  }

  guardar() {
    let valid = this.formValidatorsService.validate(this.formHeader);

    if (!this.detalleDocumentoAll || this.detalleDocumentoAll.length === 0) {
      this.toastService.error('Agregue producto(s)');
      valid = false;
    }

    if (!valid) return;

    this.processing = true;

    let detalle: any = _.cloneDeep(this.detalleDocumentoAll);
    detalle = detalle.map((detalle: IDetalleDocumento) => ({
      producto_codigo: detalle.producto_codigo,
      formato_codigo: detalle.formato_codigo,
      seleccion: detalle.seleccion,
    }));
    const inputParams = {
      entidad: {
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        rut_usuario_responsable: this.rutUsuario,
        bodega_codigo: this.formHeader.get('bodega').value,
        detalleInventarioFisico: detalle,
      },
    };

    this.log('inputParams', JSON.stringify(inputParams));

    this.inventarioFisicoService.guardarInventarioFisico(inputParams, ({ respuesta, mensajes }) => {
      this.processing = false;
      const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      this.onSuccess.emit();
      this.toastService.success('Operación exitosa');
      this.tomaInventarioModal.hide();
    });
  }

  editar() {
    let valid = this.formValidatorsService.validate(this.formHeader);

    if (!this.detalleDocumentoAll || this.detalleDocumentoAll.length === 0) {
      this.toastService.error('Agregue producto(s)');
      valid = false;
    }

    if (!valid) return;

    this.processing = true;

    let detalle: any = _.cloneDeep(this.detalleDocumentoAll);
    detalle = detalle.map((detalle: IDetalleDocumento) => ({
      producto_codigo: detalle.producto_codigo,
      formato_codigo: detalle.formato_codigo,
    }));

    const inputParams = {
      entidad: {
        rut_empresa: this.movimiento.rut_empresa,
        sucursal_codigo: this.movimiento.sucursal_codigo,
        codigo: this.movimiento.codigo,
        rut_usuario_responsable: this.rutUsuario,
        bodega_codigo: this.formHeader.get('bodega').value,
        fecha_creacion: this.movimiento.fecha_creacion,
        detalleInventarioFisico: detalle,
        estado_inventario_codigo: this.estado_inventario_codigo,
      },
    };

    this.log('inputParams', JSON.stringify(inputParams));

    this.inventarioFisicoService.editarInventarioFisico(inputParams, ({ respuesta, mensajes }) => {
      this.processing = false;
      const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      this.onSuccess.emit();
      this.toastService.success('Operación exitosa');
      this.tomaInventarioModal.hide();
    });
  }

  generarArchivoExcel() {
    const inputParams = {
      entidad: {
        rut_empresa: this.movimiento.rut_empresa,
        sucursal_codigo: this.movimiento.sucursal_codigo,
        codigo: this.movimiento.codigo,
      },
    };

    this.log('inputParams', JSON.stringify(inputParams));

    this.inventarioFisicoService.excelDocInventarioFisico(inputParams, ({ respuesta, mensajes }) => {
      const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      const { rutaArchivo } = respuesta;
      this.fileDownloadService.VerifyAndDownload(rutaArchivo);
    });
  }

  closeModal() {
    this.tomaInventarioModal.hide();
  }
}
